import React from 'react'
import tankImage from "../../../images/products/A.jpg"
import HeaderTopS3 from '../../../components/HeaderTopS3/HeaderTopS3'
import NavbarS3 from '../../../components/NavbarS3/NavbarS3'
import Logo from '../../../images/snbs_logo1.png'
import PageTitle from '../../../components/pagetitle/PageTitle'
import Footer from '../../../components/footer/Footer'
import Img from '../../../images/home/p-6.jpg'

function PpFabric() {

   const values = [
  {
    number: 1,
    text: "High strength – Strong tensile properties make it ideal for heavy-duty packaging.",
  },
  {
    number: 2,
    text: "Tear-resistant – Withstands stress during transport and handling without damage.",
  },
  {
    number: 3,
    text: "UV stabilized – Resists degradation under direct sunlight for outdoor usage.",
  },
  {
    number: 4,
    text: "Lightweight – Easy to handle, transport, and store while reducing shipping costs.",
  },
  {
    number: 5,
    text: "Customizable – Available in various widths, colors, GSMs, and lamination options.",
  },
  {
    number: 6,
    text: "Moisture-proof – Laminated versions protect against water, dust, and humidity.",
  },
  {
    number: 7,
    text: "Eco-friendly – Made using recyclable polypropylene material.",
  },
  {
    number: 8,
    text: "Multi-purpose – Suitable for sacks, ground covers, FIBCs, tarpaulins, and more.",
  },
];

  return (
    <>
     <HeaderTopS3 />
     <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
      <PageTitle pageTitle={'PP Fabric'} pagesub={'Products'} Img={Img} />
      <section className="container pt-100">
      <div className="row align-items-center">
        {/* Left Column - Text */}
        <div className="col-lg-6 col-md-12 col-sm-12 text-center">
          <img
            src={tankImage}
            alt="Water Tank" />
        </div>

        {/* Right Column - Image */}
      <div className="col-lg-6 col-md-12 col-sm-12 mb-4">
  <h2 className="fw-bold mb-3">Durable Fabrics. Dependable Packaging.</h2>
  <p style={{ textAlign: "justify" }}>
    Polypropylene (PP) woven fabric is widely used for industrial and commercial packaging due to its high strength, lightweight nature, and flexibility. In many sectors—from agriculture to logistics—reliable packaging plays a key role in protecting goods during storage and transport.
  </p>
  <p style={{ textAlign: "justify" }}>
    At SNBS, we manufacture high-quality PP woven fabric using 100% virgin polypropylene granules. Our fabric is tear-resistant, UV-stabilized, moisture-proof, and customizable in terms of width, color, and weight. It's ideal for making sacks, FIBC bags, tarpaulins, ground covers, and more.
  </p>
  <p style={{ textAlign: "justify" }}>
    Available in laminated and unlaminated forms, our PP woven fabric is strong yet economical—making it a smart choice for packaging agricultural produce, construction material, fertilizers, and industrial goods.
  </p>
</div>

      </div>
    </section>
 {/* <div className="container pt-100 pb-100">
      <h2 className="text-center fw-bold mb-4">PP Fabric</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center mb-4">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                Water tanks available in various liters
              </th>
            </tr>
            <tr>
              <th>Liter</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
          </thead>
        </table>

        <table className="table table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th colSpan="5" className="bg-primary text-white">
                PP Fabric Size Chart
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-light">
              <th>Size</th>
              <th>3000</th>
              <th>5000</th>
              <th>7500</th>
              <th>10000</th>
            </tr>
            <tr className="table-light">
              <th>Height (mm)</th>
              <td>1850</td>
              <td>2070</td>
              <td>2650</td>
              <td>3050</td>
            </tr>
            <tr className="table-light">
              <th>Diameter (mm)</th>
              <td>1550</td>
              <td>1870</td>
              <td>1940</td>
              <td>2120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> */}
<section style={{backgroundColor:"#f3f3f6"}}>
   <div className="container pt-100 pb-100" >
      <h2 className="text-center fw-bold mb-4">Product Features</h2>
      <div className="row">
        {values.map((item, index) => (
          <div key={index} className="col-md-6 mb-4 d-flex">
            <div
              className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center me-3"
              style={{ width: "40px", height: "40px", flexShrink: 0 }}>
              {item.number}
            </div>
            <p className="mb-2">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
 </section>
    <Footer hclass={'wpo-site-footer mt-0'} upperContactArea={true} />
    </>
  )
}

export default PpFabric